import { React, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import BuyProcess from "./buyProcess";

function Buy(props) {
  const { idea } = useParams();
  const navigate = useNavigate();
  const [phrase, setPhrase] = useState("");
  const [done, setDone] = useState(false);
  const [forSale, setForSale] = useState(true);
  const [Owner, setOwner] = useState(false);

  const getSingle = process.env.REACT_APP_SINGLE_REQUEST_END_POINT;
  function turnToPhrase(str) {
    return str.replace(/_/g, " ").replace(/\|/g, " ");
  }

  async function getData(idea) {
    var user = sessionStorage.getItem("userinfo");
    
    const h = {
      "Content-Type": "application/json",
    };

    var options = {
      method: "GET",
      headers: h,
    };
    await fetch(getSingle + idea, options)
      .then((response) => response.json())
      .then(function (data) {
        
        if (data.ForSale === 0) setForSale(false);
        if (
          sessionStorage.getItem("buyInfo") !== null &&
          JSON.parse(sessionStorage.getItem("buyInfo")).sellerUserId ==
            JSON.parse(sessionStorage.getItem("userinfo"))?.id
        )
          setOwner(true);

        setPhrase(turnToPhrase(data.phrase));
        sessionStorage.setItem(
          "buyInfo",
          JSON.stringify({
            phraseData: data,
            BuyerUserId:
              JSON.parse(sessionStorage.getItem("userinfo")) === null
                ? 0
                : JSON.parse(sessionStorage.getItem("userinfo"))?.id, // userId that buys
            sellerUserId: data.user.id, // userId that sells
            phraseId: data.id, //phrase
            wallet: sessionStorage.getItem("wallet"), //wallet
            forsale: false, //boolen with the intention
            price: data.value, //integer with the new price
          })
        );
      });
  }

  useEffect(() => {
    async function fetchData() {
      if (!idea) {
        navigate("/");
      } else {
        if (phrase === "") {
          await getData(idea);
          setDone(true);
        }
      }
    }
    fetchData();
  });

  function close() {
    navigate("/" + idea);
  }

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    const params = new URLSearchParams(window.location.search);
    var vars = query.split("&");
    var out = "";

    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return out;
  }

  return (
    <div className={"MainW"}>
      <Header bg={true} destination="/" from="about" />
      <div
        className={"mouse2 newbackToGalaxy text-xl"}
        onClick={(e) => close()}
      >
        {" "}
        [ BACK TO GALAXY ]{" "}
      </div>
      {Owner ? (
        <div className="flex items-center justify-center w-full h-full align-middle">
          <div className="">Sorry, you already own this idea</div>
        </div>
      ) : forSale ? (
        <div className="profile">
          <div className="left">
            <div className="phrase pl-7">{phrase}</div>
          </div>
          <div className="flex items-center justify-center w-1/2 h-full align-middle ">
            {done ? (
              //vasco
              <BuyProcess
                idea={idea}
                stage={getQueryVariable("payment_intent") ? 4 : 1}
              />
            ) : (
              <div> [ Please Wait ] </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center w-full h-full align-middle">
          <div className="">Sorry, this idea is not for sale</div>
        </div>
      )}
    </div>
  );
}

export default Buy;
